import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Banner component for SignNow brand
 *
 * @product signnow
 * @version 1.0.2
 * @category navigation
 * @contentConfig Top banner with action buttons for support and login
 * @constant BANNER_ACTION_PRIMARY - "Support" - Primary action button text
 * @constant BANNER_ACTION_SECONDARY - "Login" - Secondary action button text
 */
@Component({
  tag: 'sn-banner-type-2',
  shadow: false,
})
export class SNBannerType2 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
  }

  render() {
    return (
      <header role="banner">
        <banner-type-2>
          <me-button slot="actions" variant="tertiary" size="sm" href={getConstant(this.constants, 'LINK__BANNER_ACTION_PRIMARY', 'https://support.signnow.com')}>
            {getConstant(this.constants, 'BANNER_ACTION_PRIMARY', 'Support')}
          </me-button>
          <me-button slot="actions" variant="tertiary" size="sm" href={getConstant(this.constants, 'LINK__BANNER_ACTION_SECONDARY', 'https://app.signnow.com')}>
            {getConstant(this.constants, 'BANNER_ACTION_SECONDARY', 'Login')}
          </me-button>
        </banner-type-2>
      </header>
    );
  }
}
